<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M8 0a1.2 1.2 0 0 1 1.2 1.2v5.599l5.6.001a1.2 1.2 0 1 1 0 2.4H9.2v5.6a1.2 1.2 0 1 1-2.4 0V9.2H1.2a1.2 1.2 0 1 1 0-2.4h5.6V1.2A1.2 1.2 0 0 1 8 0z" id="vpafemfpwa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="kklsp8yutb" fill="#fff">
            <use xlink:href="#vpafemfpwa"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#vpafemfpwa"/>
        <g mask="url(#kklsp8yutb)" fill="currentColor">
            <path d="M-4-4.8h24v24H-4z" fill="transparent"/>
        </g>
    </g>
</svg>
